import styled from "styled-components";

export const WarningContainer = styled.div`
    height: 14px;
    width: 14px;
`;

export const WarningIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 14px;
    width: 14px;
    font-size: 8px;
    background-color: #bd2d2d;
    border-radius: 50%;
    color: white;
`;

